import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCollaborationPointerLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCollaborationPointerLeft"><Path d="M15.1377 14.6631L14.7822 14.7822L14.6631 15.1377L12.5381 21.5127L13.9619 21.9873L15.9688 15.9678L21.9873 13.9619L21.5127 12.5381L15.1377 14.6631Z" fill="currentColor"/><Path d="M9.37305 21.585L12.5869 12.5859L21.585 9.37305L3.58887 3.58887L9.37305 21.585Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCollaborationPointerLeft;
